var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_c('a',{attrs:{"href":"https://www.votonia.ru"}},[_c('div',{staticClass:"fr_bold"},[_c('span',[_c('font-awesome-icon',{attrs:{"icon":"shopping-cart"}})],1),_vm._v(" продолжить покупки на votonia.ru ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }